/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * DeviceService.ts
 */

import KareviAPIService from "../tools/service/KareviAPIService";
import Device from "../models/Device";
import {Listener} from "../tools/service/Service";
import Client from "../models/Client";

export default class DeviceService extends KareviAPIService<Device, Listener<Device>> {
    public static SINGLE_ROUTE = '/oauth/client/{clientId}/device/{deviceId}';
    public static LIST_ROUTE = '/oauth/client/{clientId}/devices';
    public static id = "DeviceService";

    /**
     * start
     */
    public start() {
        super.start();
    }

    /**
     * stop
     */
    public stop() {
        super.stop();
    }

    /**
     * createDevice
     * @return {Promise<Device>}
     * @param dto
     * @param client
     */
    public async createDevice(client: Client, dto: Map<string, any>): Promise<Device> {
        const route = this.httpService.buildRoute(DeviceService.LIST_ROUTE, {
            clientId: client.id
        })

        return await this.post(route, dto);
    }

    /**
     * findById
     * @returns {Promise<void>}
     */
    public async deleteById(client: Client, device: Device): Promise<Boolean> {
        const route = this.httpService.buildRoute(DeviceService.SINGLE_ROUTE, {
            clientId: client.id,
            deviceId: device.id
        });

        return await this.delete<Device>(route);
    }

    /**
     * findAll
     * @returns {Promise<Device[]>}
     */
    public async findAll(client: Client): Promise<Device[]> {
        const route = this.httpService.buildRoute(DeviceService.LIST_ROUTE, {
            clientId: client.id
        })

        return await this.getList(route);
    }
}
